import validator from 'validator';

export default function isFallBackToWhiteCOlor(hex_value) {
  return hex_value.toLowerCase() === '#ffffff' || !validator.isHexColor(hex_value)
}



// WEBPACK FOOTER //
// ./src/helpers/isFallBackToWhiteColor.js